export const LISTA_OPCIONES_REPORTE = {
    ESTADO_RESULTADOS_FLUJO_EFECTIVO:"Estado de Resultados/Flujo de Efectivo",
    // CORTE_CAJA:"Corte de Caja",
    VENTAS:"Ventas",
    PAGOS:"Pagos",
    // EGRESOS:"Egresos",
    ESTADISTICA_VENTAS_COLABORADOR:"Estadística Ventas X Colaborador",
    ESTADISTICA_VENTAS_PRODUCTO:"Estadística Ventas X Producto",
    // ESTADISTICA_VENTAS_SERVICIO:"Estadística Ventas X Servicio",
    // ESTADISTICA_COMPRAS_PROVEEDOR:"Estadística Compras X Proveedor",
    ESTADISTICA_VENTAS_MES:"Estadística Ventas Mex X Mes",
    // COMPARATIVA_VENTAS_TEMPORADA:"Comparativa Ventas X Temporada",
    // FALTANTES:"Faltantes",
    // ESTADO_CUENTA_PROVEEDORES:"Estado de Cuenta Proveedores",
    // MOROSOS:"Morosos",
    // ESTADISTICA_SERVICIO_CONCEPTO:"Estadística de Servicio X Concepto",
    // CONSOLIDADO_VENTAS:"Consolidado de Ventas",
    // CONSOLIDADO_UTILIDAD:"Consolidado de Utilidad",
    // CONSOLIDADO_PRODUCTIVIDAD:"Consolidado de Productividad",
    // ASISTENCIA_COLABORADORES:"Asistencia Colaboradores",
    // SALDO_FAVOR:"Saldo a Favor",
    // COMISIONES_COLABORADOR:"Comisiones Colaborador",
    COMPRAS:"Compras",
   
}

export const LISTA_OPCIONES_REPORTE_DESDE = {
    HISTORIA:'Historia',
    MOSTRADOR:'Mostrador',
    TODOS:'Todos',
}

export const LISTA_OPCIONES_REPORTE_AGRUPAR = {
    DIA:'Día',
    SEMANA:'Semana',
    MES:'Mes',
    ANIO:'Año',
}

export const LISTA_OPCIONES_REPORTE_AGRUPAR_POR = {
    CATEGORIA:'Categoría',
    PROPIETARIO:'Propietario',
}

export const LISTA_OPCIONES_REPORTE_ESTATUS = {
    DEUDA:'Deuda',
    PAGADO:'Pagado',
    AMBOS:'Ambos',
}

export const LISTA_OPCIONES_REPORTE_PAGO = {
    VISA:'Visa',
    MASTER:'Master',
    OTRO:'Otro',
    TODOS:'Todos',
    AMEX:'Amex',
}

export const LISTA_OPCIONES_REPORTE_OPCIONES = {
    SI:'Si',
    NO:'No',
    AMBOS:'Ambos',
}

export const LISTA_OPCIONES_REPORTE_PROVEEDORES = {
    INTERNO:'Interno',
    EXTERNO:'Externo',
    AMBOS:'Ambos',
}

export const LISTA_OPCIONES_REPORTE_IMPRIMIR = {
    PANTALLA:'Pdf',
    EXCEL:'Excel',
}

export const LISTA_OPCIONES_REPORTE_CATEGORIA = {
    FACTURA:'Factura',
    RECIBO:'Recibo',
    TODO:'Todo',
}

export const LISTA_OPCIONES_REPORTE_MOSTRAR = {
    PESOS:"$",
    UNIDAD:"Unid."
}


export const LISTA_TIPOS_SERVICIOS = [
    {
        value: null,
        text: 'Seleccione una opción',
    },
    {
        value: 'PRODUCTO',
        text: 'Producto',
    },
    {
        value: 'SERVICIO',
        text: 'Servicio',
    },
    {
        value: 'ESTUDIO',
        text: 'Estudio',
    },
]


// WEBPACK FOOTER //
// ./src/constantes/reportes/utils.js